import { API_URL, setHeader } from 'api';
import axios from 'axios';
import parseInt from 'lodash/parseInt';
import map from 'lodash/map';
import flatMap from 'lodash/flatMap';
import isEqual from 'lodash/isEqual';

const URL = `${API_URL}/questionnaire`;

export const fetchQuestionnaireQuestions = params => {
  const req = setHeader(axios);
  return req.get(`${URL}`, { params });
};

export const createQuestionnaireQuestion = obj => {
  const req = setHeader(axios);
  return req.post(`${URL}/question`, {
    question: obj.question,
    answerLimit: obj.answerLimit,
    answers: map(obj.answers, a => {
      return {
        answer: a.answer,
        score: parseInt(a.score),
        autoFail: a.autoFail,
      };
    }),
    weight: parseInt(obj.weight),
    displayCategoryID: obj.displayCategory.categoryID,
    questionTypeID: obj.questionType.typeID,
    controlID: obj.controlID,
    defaultQuestion: obj.defaultQuestion,
  });
};

export const updateQuestionnaireQuestion = obj => {
  const req = setHeader(axios);
  return req.put(`${URL}/question`, {
    originalID: obj.originalID ? obj.originalID : obj.questionID,
    question: obj.question,
    weight: parseInt(obj.weight),
    questionTypeID:
      typeof obj.questionTypeID.typeID === 'number'
        ? obj.questionTypeID.typeID
        : obj.questionTypeID,
    displayCategoryID:
      typeof obj.displayCategoryID.categoryID === 'number'
        ? obj.displayCategoryID.categoryID
        : obj.displayCategoryID,
    questionID: obj.questionID,
    controlID: obj.controlID,
    defaultQuestion: obj.defaultQuestion,
  });
};

export const updateQuestionnaireDraftQuestion = obj => {
  const req = setHeader(axios);
  return req.put(`${URL}/question/draft`, {
    question: obj.question,
    weight: parseInt(obj.weight),
    questionTypeID:
      typeof obj.questionTypeID.typeID === 'number'
        ? obj.questionTypeID.typeID
        : obj.questionTypeID,
    displayCategoryID:
      typeof obj.displayCategoryID.categoryID === 'number'
        ? obj.displayCategoryID.categoryID
        : obj.displayCategoryID,
    questionID: obj.questionID,
    controlID: obj.controlID,
    defaultQuestion: obj.defaultQuestion,
  });
};

export const createQuestionnaireAnswer = (obj, questionID) => {
  const req = setHeader(axios);
  return req.post(`${URL}/answer`, {
    answer: obj.answer,
    questionID,
    score: parseInt(obj.score),
    autoFail: obj.autoFail,
  });
};

export const updateQuestionnaireAnswer = (obj, questionID) => {
  const req = setHeader(axios);
  return req.put(`${URL}/answer`, {
    answerID: obj.answerID,
    answer: obj.answer,
    score: parseInt(obj.score),
    autoFail: obj.autoFail,
    originalID: obj.originalID ? obj.originalID : obj.answerID,
    questionID: questionID,
  });
};

export const updateQuestionnaireDraftAnswer = (obj, questionID) => {
  const req = setHeader(axios);
  return req.put(`${URL}/answer/draft`, {
    answerID: obj.answerID,
    answer: obj.answer,
    score: parseInt(obj.score),
    autoFail: obj.autoFail,
    questionID: questionID,
  });
};

export const archiveQuestionnaireQuestion = (id, status) => {
  const req = setHeader(axios);
  if (status === 'Active') {
    return req.put(`${URL}/question/${id}`);
  } else {
    return req.delete(`${URL}/question/draft/${id}`);
  }
};

export const archiveQuestionnaireAnswer = (id, status) => {
  const req = setHeader(axios);
  if (status === 'Active') {
    return req.put(`${URL}/answer/${id}`);
  } else {
    return req.delete(`${URL}/answer/draft/${id}`);
  }
};

export const publishQuestionnaireQuestions = () => {
  const req = setHeader(axios);
  return req.put(`${URL}/publish`);
};

export const fetchQuestionnaireInstance = ({ status, vendorRequestID }) => {
  const req = setHeader(axios);
  return req.get(`${URL}/instance/${vendorRequestID}`, {
    params: { status },
  });
};

export const saveQuestionnaire = (action, vendorRequestID, _questions) => {
  const req = setHeader(axios);
  const questions = map(_questions, q => {
    q.answers = flatMap(q.answers, a => {
      if (isEqual(a, q.selected) || isEqual(a.answerID, q.selected[0])) {
        return [{ answerID: a.answerID, selected: true, answer: a.answer }];
      } else {
        return [{ answerID: a.answerID, selected: false, answer: a.answer }];
      }
    });
    return {
      questionID: q.questionID,
      note: q.note,
      answers: q.answers,
    };
  });
  return req.put(`${URL}/instance`, {
    action,
    vendorRequestID: parseInt(vendorRequestID),
    questions,
  });
};

export const submitQuestionnaire = (action, vendorRequestID) => {
  const req = setHeader(axios);
  return req.put(`${URL}/instance`, {
    action,
    vendorRequestID: parseInt(vendorRequestID),
  });
};

export const fetchScores = id => {
  const req = setHeader(axios);
  return req.get(`${URL}/scores/${id}`);
};

export const updateScore = (id, body) => {
  const req = setHeader(axios);
  return req.put(`${URL}/scores/${id}`, { ...body });
};

export const reorderQuestions = questions => {
	const req = setHeader(axios);
	const justOrderStuff = questions.map(q => {
		return {
			questionID: q.questionID,
			displayOrder: q.displayOrder
		}
	});
	return req.post(`${URL}/questionorder`, {
		questions: justOrderStuff
	});
};